export default "__VITE_ASSET__BrKvzf29__"